import { Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  paddingLeft: theme.spacing(0.5)
}))

export const StyledScrollBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sectionMaxHeight"
})<{ sectionMaxHeight: number | string }>(({ theme, sectionMaxHeight }) => ({
  maxHeight: sectionMaxHeight,
  overflowY: "auto",
  overflowX: "hidden",
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2
  }
}))
